import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import { boolean, object, SchemaOf, string } from "yup";
import { useFormik } from "formik";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { loginAction, verifyOTPAction } from "src/app-redux/auth/actions/authActions";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { payLoadValues, setIsLoggedIn, setPayloadValues } from "src/app-redux/auth/authSlice";

interface IForm {
  code: string;
  rememberMe?: boolean;
}

const validationSchema: SchemaOf<IForm> = object({
  code: string().required("OTP is required"),
  rememberMe: boolean().notRequired(),
});

export function VerifyOTP() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const request: any = useAppSelector(payLoadValues);
  const [showResendButton, setShowResendButton] = useState<boolean>(false);
  const [removeInterval, setRemoveInterval] = useState<boolean>(false);

  useEffect(() => {
    if (!removeInterval) {
      const interval = setInterval(() => {
        const otpTime = localStorage.getItem("otpTime") || ""?.split(":");

        if (
          (new Date().getMinutes() == Number(otpTime[0]) + 1 &&
            new Date().getSeconds() > Number(otpTime[1])) ||
          new Date().getMinutes() > Number(otpTime[0]) + 1
        ) {
          setShowResendButton(true);
          clearInterval(interval);
        }
      }, 1000);
    }
  }, [showResendButton]);

  const formik = useFormik<IForm>({
    initialValues: {
      code: "",
      rememberMe: false,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const model = {
        userName: request.username,
        code: values.code,
        rememberMe: values.rememberMe || false,
      };
      const res: any = await dispatch(verifyOTPAction(model)); // LoginAction
      if (res.payload) {
        setRemoveInterval(true);
        dispatch(setIsLoggedIn(true));
        const menus: any = res.userMenus;
        if (menus.length) {
          localStorage.setItem(
            "defaultRoute",
            res.userMenus[0].routeName + res.userMenus[0].childMenus[0].routeName
          );

          const allowedRoutes: any = [];
          res.userMenus.forEach((menuItem: any) => {
            allowedRoutes.push(menuItem.routeName);
            const arr: any[] = menuItem.childMenus;
            if (arr.length) {
              arr.forEach((subItem: any) => {
                allowedRoutes.push(menuItem.routeName + subItem.routeName);
              });
            }
          });
          localStorage.setItem("allowedRoutes", JSON.stringify(allowedRoutes));

          history.push(res.userMenus[0].routeName + res.userMenus[0].childMenus[0].routeName); // Dynamic Menus
        } else {
          localStorage.setItem("defaultRoute", "/unauthorized");
          localStorage.setItem("allowedRoutes", JSON.stringify([]));
          history.push("/unauthorized"); // Return to homescreen
        }
      }
    },
  });

  const goToLogin = () => {
    localStorage.clear();
    location.reload();
  };

  const resendOtp = async () => {
    const res = await dispatch(loginAction(request)); // LoginAction
    dispatch(setPayloadValues(res.meta?.arg));
    localStorage.setItem(
      "otpTime",
      JSON.stringify(`${new Date().getMinutes()}:${new Date().getSeconds()}`)
    );
    setShowResendButton(false);
  };

  return (
    <div className="form-wrapper">
      <h4 className="form-heading">Verify OTP</h4>
      <form onSubmit={formik.handleSubmit}>
        <TextField
          size="small"
          fullWidth
          variant="outlined"
          className="customTextField"
          InputLabelProps={{
            shrink: true,
          }}
          label="OTP"
          name="code"
          value={formik.values.code}
          onChange={formik.handleChange}
          error={formik.touched.code && Boolean(formik.errors.code)}
          helperText={formik.touched.code && formik.errors.code}
        />
        <Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(formik.values.rememberMe)}
                onChange={formik.handleChange}
                name="rememberMe"
                color="primary"
              />
            }
            label="Remember Me"
          />
        </Box>
        <Box m={1} />

        {showResendButton ? (
          <Box className="resend-text" onClick={resendOtp}>
            Resend
          </Box>
        ) : (
          <Box className="resend-text-disabled">Resend</Box>
        )}

        <Box m={3} />
        <Box textAlign="right" mt={1} mb={1}>
          <Button className="btns-otp-screen cancel-button" variant="contained" onClick={goToLogin}>
            Cancel
          </Button>

          <Button
            className="btns-otp-screen login-button"
            type="submit"
            variant="contained"
            color="secondary"
          >
            Submit
          </Button>
        </Box>
      </form>
    </div>
  );
}
